// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__Low-L","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__8EwZV"};